import React, { Dispatch, useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { DarkModeContext } from "../darkModeContext";
import { useTranslation } from "../i18n";
import "./Sidebar.css";
import HomeIcon from "../icons/home.svg";
import RouteIcon from "../icons/route.svg";
import QuestionMarkIcon from "../icons/question-mark.svg";
import PeopleIcon from "../icons/people.svg";
import BurgerIcon from "../icons/burger.svg";

type NavLinkStyleFun = (props: { isActive: boolean }) => React.CSSProperties;

function Sidebar(props: { setShowOnboarding: Dispatch<boolean>, language: string, setLanguage: Dispatch<string> }) {
  
  const t = useTranslation();
  const applyActiveStyle: NavLinkStyleFun = (props) =>
    props.isActive ? { opacity: 1 } : {};
  const loc = useLocation();
  const [darkMode, setDarkMode] = useContext(DarkModeContext);
  const shouldAllowCollapse = window.innerWidth < 760;
  const [sidebarCollapsed, setSidebarCollapsed] = useState(shouldAllowCollapse);

  // For mobile, collapse sidebar on navigation between tabs/pages
  useEffect(() => {
    if (shouldAllowCollapse) {
      setSidebarCollapsed(true);
    }
  }, [shouldAllowCollapse, loc.pathname]);

  return (
    <>
    {sidebarCollapsed ? 
      <div className="sidebar sidebar-toggle collapsed"><button onClick={()=>setSidebarCollapsed(!sidebarCollapsed)} className="sidebar-toggle-btn"><BurgerMenuIcon/></button> </div> 
    :
    <div className="sidebar">
      {shouldAllowCollapse && <div className="sidebar-toggle" > <button onClick={()=>setSidebarCollapsed(!sidebarCollapsed)} className="sidebar-toggle-btn"><BurgerMenuIcon/></button> </div>}

      <div className="logoContainer">
        <img height={124} width={"auto"} src="/havdata-logo.svg" alt="logo" />
      </div>
      <NavLink to="/" style={applyActiveStyle} className="navLink">
        <img height={24} width="auto" src={HomeIcon} alt="Map" />{" "}
        {t("Sidebar.FishMap")}
      </NavLink>
      <NavLink to="/route-planner" style={applyActiveStyle} className="navLink">
        <img
          height={24}
          width="auto"
          src={RouteIcon}
          alt={t("Sidebar.Planner")}
        />
        {t("Sidebar.Planner")}
      </NavLink>
      <Link to={loc.pathname} onClick={() => props.setShowOnboarding(true)} className="navLink">
        <img
            height={24}
            width="auto"
            src={QuestionMarkIcon}
            alt=""
          />
        {t("Sidebar.Help")}
      </Link>
      <NavLink to="/about" style={applyActiveStyle} className="navLink">
        <img
          height={24}
          width="auto"
          src={PeopleIcon}
          alt={t("Sidebar.About")}
        />
        {t("Sidebar.About")}
      </NavLink>
      <div>
        <br />
        <br />
      </div>
      <div className="settingsSection">
        <button
          className="darkButton"
          onClick={() => setDarkMode(!darkMode)}
        >{t("Sidebar.DarkModeButton", { mode: darkMode ? t("Sidebar.LightMode") : t("Sidebar.DarkMode") })}</button>
        <button
          className="darkButton"
          style={{ marginLeft: "10px" }}
          onClick={() => props.setLanguage(props.language === 'no' ? 'en' : 'no')}
        >{props.language === "no" ? "English" : "Norsk" }</button>
      </div>
    </div>
  }
    </>
  );
}

function BurgerMenuIcon() {
  return <img
    height={16}
    width="auto"
    src={BurgerIcon}
    alt={"Show/Hide Menu"}
  />;
}

export default Sidebar;
